import { render, staticRenderFns } from "./publicTransferDetails.vue?vue&type=template&id=e354efd0&scoped=true"
import script from "./publicTransferDetails.vue?vue&type=script&lang=js"
export * from "./publicTransferDetails.vue?vue&type=script&lang=js"
import style0 from "./publicTransferDetails.vue?vue&type=style&index=0&id=e354efd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e354efd0",
  null
  
)

export default component.exports